import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "carSearch"
const CarSearchIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            d="M15.6952916,18.0523933 C14.0714806,19.2063412 12.0861808,19.8848252 9.94241261,19.8848252 C4.45136975,19.8848252 -2.7533531e-13,15.4334555 -2.7533531e-13,9.94241261 C-2.7533531e-13,4.45136975 4.45136975,0 9.94241261,0 C15.4334555,0 19.8848252,4.45136975 19.8848252,9.94241261 C19.8848252,12.0863907 19.2062083,14.0718693 18.0520543,15.6957686 L23.7046314,21.3501528 C24.0950177,21.7406639 24.0950177,22.3737634 23.7046314,22.7642745 L22.7621347,23.7070725 C22.3716895,24.0976425 21.7386088,24.0976425 21.3481636,23.7070725 L15.6952916,18.0523933 Z M15.1992108,7.87331836 C14.9039668,6.34142141 14.1413373,5 12.1714286,5 L7.88571429,5 C5.91580553,5 5.15317604,6.34142141 4.85793204,7.87331836 C4.79736366,7.86268696 4.73504356,7.85714286 4.67142857,7.85714286 C4.07969491,7.85714286 3.6,8.33683777 3.6,8.92857143 C3.6,9.52030509 4.07969491,10 4.67142857,10 L4.67511739,9.99999378 C4.67142857,10.2499249 4.67142857,10.4899349 4.67143152,10.7142857 L4.67142857,10.7163781 L4.67142857,14.2836219 C4.67142857,14.6872276 4.99422132,15 5.39240635,15 L6.80759365,15 C7.21189059,15 7.52857143,14.6792666 7.52857143,14.2836219 L7.52857143,13.5714286 L12.5285714,13.5714286 L12.5285714,14.2836219 C12.5285714,14.6872276 12.8513642,15 13.2495492,15 L14.6647365,15 C15.0690334,15 15.3857143,14.6792666 15.3857143,14.2836219 L15.3857143,10.7142857 C15.3857143,10.4899349 15.3857143,10.2499249 15.3820255,9.99999378 L15.3857143,10 C15.9774479,10 16.4571429,9.52030509 16.4571429,8.92857143 C16.4571429,8.33683777 15.9774479,7.85714286 15.3857143,7.85714286 C15.3220993,7.85714286 15.2597792,7.86268696 15.1992108,7.87331836 Z M13.8896715,8.79048248 C13.9068638,8.95762944 13.919892,9.11717747 13.9296822,9.28571429 L6.12746065,9.28571429 C6.13725087,9.11717747 6.15027909,8.95762944 6.16747135,8.79048248 C6.34225823,7.09116561 6.8022879,6.42857143 7.88571429,6.42857143 L12.1714286,6.42857143 C13.254855,6.42857143 13.7148846,7.09116561 13.8896715,8.79048248 Z M6.81428571,12.3214286 C6.32117433,12.3214286 5.92142857,11.9216828 5.92142857,11.4285714 C5.92142857,10.93546 6.32117433,10.5357143 6.81428571,10.5357143 C7.3073971,10.5357143 7.70714286,10.93546 7.70714286,11.4285714 C7.70714286,11.9216828 7.3073971,12.3214286 6.81428571,12.3214286 Z M13.2428571,12.3214286 C12.7497458,12.3214286 12.35,11.9216828 12.35,11.4285714 C12.35,10.93546 12.7497458,10.5357143 13.2428571,10.5357143 C13.7359685,10.5357143 14.1357143,10.93546 14.1357143,11.4285714 C14.1357143,11.9216828 13.7359685,12.3214286 13.2428571,12.3214286 Z"
            id="path-1"
          />
        </svg>
      }
    </span>
  )
}
export default CarSearchIcon
